export default "__VITE_ASSET__AFWQAj32__"